// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentful-entity-field .contentful-entity-field-slot {
  margin-top: 0;
  margin-bottom: 10px; }

.contentful-entity-field.disabled {
  filter: grayscale(80%); }
`, "",{"version":3,"sources":["webpack://./src/components/contentful/EntityField.scss"],"names":[],"mappings":"AAAA;EAEI,aAAa;EACb,mBAAmB,EAAA;;AAHvB;EAOI,sBAAsB,EAAA","sourcesContent":[".contentful-entity-field {\n  .contentful-entity-field-slot {\n    margin-top: 0;\n    margin-bottom: 10px;\n  }\n\n  &.disabled {\n    filter: grayscale(80%);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
